import React, { Component } from 'react';
import { connect } from "react-redux";

class Badge extends Component {

    constructor(props) {
        super(props);
        this.state = {
            badgeType: ''
        }
        }

        componentDidMount () {
            if (this.props.service) {
                this.setState({badgeType: 'service'})
            }
            else if (this.props.completed) {
                this.setState({badgeType: 'completed'})
            }
            else if (this.props.type) {
                this.setState({badgeType: this.props.type});  
            }
            else if (this.props.status) {
                if (this.props.status == 2 || this.props.status == 1) 
                    this.setState({badgeType: 'approved'});
                else if (this.props.status >= 3)
                    this.setState({badgeType: 'pending'});
                else if (this.props.status < 0) {
                    this.setState({badgeType: 'cancelled'})
                }
            }
        }
    


    render() {
        return (
            <div id="booking_badge_container">
                <div id="booking_badge" className={this.state.badgeType} style={{textTransform: 'uppercase'}}>
                    {this.state.badgeType}
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(Badge)